import React, {useState, useRef} from 'react';
import ActionItemDropdownFormAssignedList from './ActionItemDropdownFormAssignedList.mjs';
import ActionItemDropdownFormShortList from './ActionItemDropdownFormShortList.mjs';
import ActionItemDropdownFormLongList from './ActionItemDropdownFormLongList.mjs';
import ActionItemDropdownFormTeamList from './ActionItemDropdownFormTeamList.mjs';

import { useCTAL } from './CTAL_Hooks.js';
import './Card.css';

export default function ActionItemDropdownList({sel_action_item}) 
{
    const { user_id, app_user, action_item_list_display, 
            action_item, setSelectedActionItem, setActionItemDisplayRefresh,
            setActionItemShortListRefresh, setActionItemLongListRefresh, setActionItemTeamListRefresh,
            setActionItemShortListCountRefresh, setActionItemLongListCountRefresh } = useCTAL();
    
    const [error, setError]     = useState();
    const fetchRef = useRef("");

    const refresh_action_item = () => { 
        //Only Refresh Action Item if it's already selected
        if ((action_item != undefined) && (action_item.Name == sel_action_item.Name)) {
            setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
            setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs     
        }
    }

    const refresh_action_item_list = (type) => { 
        switch(action_item_list_display)
        {
            case "user-short-list-display":
                setActionItemShortListRefresh(true);
                setActionItemShortListCountRefresh(true);
                if (type == "release_action_item") setActionItemLongListCountRefresh(true);
                break;
            case "user-long-list-display":
                setActionItemLongListRefresh(true);
                setActionItemLongListCountRefresh(true);
                if (type == "take_action_item") setActionItemShortListCountRefresh(true);
                break;
            case "team-display":
            case "team-assigned-display":
                setActionItemTeamListRefresh(true);
                if (type == "take_action_item") setActionItemShortListCountRefresh(true);
                break;
            case "user-app-admin-display":
            default:
                return;
        }
    }

    const set_action_item = (set_body) => { 
        console.log(`ActionItemDropdownList - Set Action Item set_body: ${set_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: set_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: set_body })
            .then(() => refresh_action_item())
            .catch(setError);
    }
    
    const update_action_item = (upd_body) => { 
        console.log(`ActionItemDropdownList - Update Action Item upd_body: ${upd_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: upd_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: upd_body })
            .then(() => refresh_action_item_list(fetchRef.id))
            .then(() => refresh_action_item())
            .catch(setError);
    }


    const DropDownAction = (type, comment="") => { 
        var action_item_id = sel_action_item.ActionItemID;
        var user_full_name = app_user.UserFullName;
        var body, action_item_name;
        
        fetchRef.id = type;
        
        switch (type)
        {
            case "accept_action_item_assignment":
            case "release_action_item":
                body = JSON.stringify({type, action_item_id, user_id});
                update_action_item(body);
                break;
            case "reject_action_item_assignment":
                var reason = comment;
                body = JSON.stringify({type, action_item_id, user_id, reason});
                update_action_item(body);
                break;
            case "take_action_item":
            case "delete_action_item_ui":
            case "upd_action_item_progress_done":
            case "close_action_item":
                action_item_name = sel_action_item.Name;
                body = JSON.stringify({type, action_item_id, action_item_name, user_id, user_full_name});
                update_action_item(body);
                break;
            case "upd_priority_on_fire":
            case "upd_priority_hot":
            case "upd_priority_normal":
            case "upd_priority_low":
                var prior_priority = sel_action_item.Priority;
                body = JSON.stringify({type, action_item_id, user_id, user_full_name, prior_priority});
                update_action_item(body);
                break;
            case "create_comment":
                var comment_type = "Action-Item";
                var target_pk = action_item_id;
                var target_sk = action_item_id;
                body = JSON.stringify({type, comment_type, target_pk, target_sk, user_full_name, comment});
                set_action_item(body);
                break;
            default:
                break;
        }
    }

    switch(action_item_list_display)
    {
        case "user-short-list-display":
            return ( <ActionItemDropdownFormShortList sel_action_item={sel_action_item} action={DropDownAction} /> );
        case "user-long-list-display":
            return ( <ActionItemDropdownFormLongList sel_action_item={sel_action_item} action={DropDownAction} /> );
        case "team-display":
            return ( <ActionItemDropdownFormTeamList sel_action_item={sel_action_item} action={DropDownAction} /> );
        case "team-assigned-display":
            return ( <ActionItemDropdownFormAssignedList sel_action_item={sel_action_item} action={DropDownAction} /> );
        case "user-app-admin-display":
        default:
            return ( <></> );
    }
}